import { Space, Tabs, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TLogoSelection } from '../../../interfaces/logo.interface';

import { LOGOS } from '../../../const/logos';
import { useWorkspaceStore } from '../../../store/workspace.store';
import DefaultLogo from './DefaultLogo';
import UploadLogo from './UploadLogo';

interface ISelectLogoContent {
    showTitle?: boolean;
    setDefaultLogo?: (param: string) => void
}

const styles = {
    width: '100%',
    padding: 20,
    background: '#F2F8FF',
    marginTop: 16,
    border: '1px solid #E5E5E5',
    borderRadius: 4,
}

const { Text } = Typography;

const SelectLogoContent = ({
    showTitle,
    setDefaultLogo
}: ISelectLogoContent) => {
    const { t: cw } = useTranslation('onboarding', { keyPrefix: 'CREATE_WORKSPACE' });

    const [logoSelection, setLogoSelection] = useState<TLogoSelection>("UPLOAD");
    const [currentSrc, setCurrentSrc] = useState<string | null>(null);
    const [existDefaultLogo, setExistDefaultLogo] = useState<null | string>(null);

    const workspace = useWorkspaceStore((state) => state.data);

    const items = [
        {
            key: 'UPLOAD',
            label: cw('HAVE_A_LOGO'),
            children: (
                <div style={styles}>
                    <UploadLogo
                        setCurrentSrc={setCurrentSrc}
                        currentSrc={currentSrc}
                    />
                </div>
            )
        },
        {
            key: 'SELECT',
            label: cw('DO_NOT_HAVE_A_LOGO'),
            children: (
                <div style={styles}>
                    <DefaultLogo
                        existDefaultLogo={existDefaultLogo}
                        setDefaultLogo={setDefaultLogo}
                        type={existDefaultLogo || ''}
                        color={existDefaultLogo || ''}
                        url={existDefaultLogo || ''}
                        background={existDefaultLogo || ''}
                    />
                </div>
            )
        },
    ];

    useEffect(() => {
        if (!workspace || !workspace.image) return;

        const findLogo = LOGOS.driver.find((logo) => logo.url === workspace.image);

        if (findLogo) {
            setLogoSelection('SELECT');
            setExistDefaultLogo(findLogo.type);
        } else {
            setCurrentSrc(workspace.image);
            setLogoSelection('UPLOAD');
        }
    }, [workspace]);

    return (
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
            {
                showTitle ? (
                    <Text>
                        {cw('BRAND_INFORMATION')}
                    </Text>
                ) : null
            }

            <Tabs
                defaultActiveKey="UPLOAD"
                onChange={(key) => setLogoSelection(key as TLogoSelection)}
                items={items}
            />
        </Space>
    )
}

export default SelectLogoContent;